<pv-toolbar backAction="custom" title="{{ 'tasks.tasks' | translate }}" (back)="goToResidentOverview()" />
<empty-state icon="fa fa-tasks" [message]="'tasks.not_found' | translate" />
